export default __webpack_public_path__ + "static/media/advancing-justice-logo.4face1f1.png";